import outboxApi from '@/api/outbox/outbox'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'
import { globalModule, commonComponentModule } from '@/store/moduleName'
import jwtTokenApi from '@/api/general/jwtToken'
import { mapGetters } from 'vuex'
import CryptoUtil from '@/lib/g2e/CryptoUtil.js'
import messageUtil from '@/utils/messageUtil'

export const encryptMethod = {
  computed: {
    ...mapGetters(commonComponentModule, ['decryptedFileKey'])
  },
  methods: {
    getSecurityOpenerList: async function (entityIds, securityLevel) {
      let hasError = false
      let securityOpenerList = []
      await outboxApi.getEDocXEuidListBySecurityLevelId(entityIds, securityLevel, resp => {
        if (resp.status === 201 || resp.status === 200) {
          securityOpenerList = resp.data
        } else {
          hasError = true
        }
      })
      if (hasError) {
        throw new Error('error in getting euid list by security level')
      }
      return securityOpenerList
    },
    getMissSecurityList: function (entityIds, securityOpenerList) {
      let missingEntityIds = []
      entityIds.forEach(entityId => {
        let found = false
        securityOpenerList.every(receiver => {
          if (((entityId + '') === (receiver.originalEntityId + '')) && !isArrayEmptyOrNull(receiver.users)) {
            found = true
            return false
          }
          return true
        })
        if (!found) {
          missingEntityIds.push(entityId)
        }
      })
      return missingEntityIds
    },
    // if user has no key pair, show alert message
    async checkAndShowNoKeyPairUser (userList) {
      let noKeyPairUsers = []
      let name = ''
      if (userList && userList.length) {
        // show message 'encrypt.msgUserKeyPairNotSetup'
        noKeyPairUsers = await this.getNoKeyPairUsers(userList)
        if (noKeyPairUsers && noKeyPairUsers.length) {
          for (const user of noKeyPairUsers) {
            name += '<br>' + (user.chinName ? user.chinName + ' ' : '') + user.portName
          }
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t('encrypt.msgUserKeyPairNotSetup') + ', ' + this.$t('encrypt.plsaseRemoveUser') + '：' + name)
        }
      }

      return (noKeyPairUsers.length > 0)
    },
    async getNoKeyPairUsers (userList) {
      let noKeyPairUsers = []
      let publicKeyList = []
      let euidList = []

      for (const user of userList) {
        euidList.push(user.euid)
      }
      await jwtTokenApi.getPublicKeys(euidList, resp => {
        if (resp.status === 200 || resp.status === 201) {
          publicKeyList = resp.data
        }
      })

      if (publicKeyList.length === euidList.length) {
        return noKeyPairUsers
      } else {
        for (const user of userList) {
          if (!publicKeyList.find(key => key.euid === user.euid)) {
            noKeyPairUsers.push(user)
          }
        }
      }

      return noKeyPairUsers
    },
    async buildEncryptedOpenerData (euidList) {
      let publicKeyList = []
      let openerList = []
      await jwtTokenApi.getPublicKeys(euidList, resp => {
        if (resp.status === 200 || resp.status === 201) {
          publicKeyList = resp.data
        } else {
          messageUtil.httpStatusHandler(resp, this)
        }
      })
      // console.log('publicKeyList: ' + JSON.stringify(publicKeyList))
      // array.forEach doesn't wait for promise
      for (const e of publicKeyList) {
        let encryptedFileKey = await CryptoUtil.PGPTool.encryptText(this.decryptedFileKey, e.publicKey)
        // console.log('forEach: ' + e.euid + ',  key: ' + encryptedFileKey)
        openerList.push({
          openerKey: encryptedFileKey,
          euid: e.euid,
          keyPairId: e.id
        })
      }

      return openerList
    }
  }
}
